export const VOLUME_LIST_CODE = "unitVolume"
export const WEIGHT_LIST_CODE = "unitWeight"
export const UNIT_LIST_CODE = "unitOtherPhyto"
